import axios from 'axios'
import { getAuthHeaders } from '@/services/auth.credentials'
import type { DCCastroomInfo } from '@dronecast/shared'

const API_BASE_URL = '/dronecast/1.0'

/**
 * Dronecast HTTP API 서비스
 *
 * Store에서 API 호출을 분리하여, Store는 순수 상태 컨테이너로 유지한다.
 */
export const dronecastApiService = {
  async fetchCastrooms(gcsId?: string): Promise<DCCastroomInfo[]> {
    const headers = getAuthHeaders()
    const url = gcsId
      ? `${API_BASE_URL}/castroom?gcsId=${gcsId}`
      : `${API_BASE_URL}/castroom`
    const response = await axios.get(url, { headers })
    return response.data.castRooms as DCCastroomInfo[]
  },

  async fetchCastroom(streamId: string): Promise<any> {
    const headers = getAuthHeaders()
    const response = await axios.get(`${API_BASE_URL}/castroom/${streamId}`, { headers })
    return response.data
  },
}
